import React from 'react';

import PropTypes from 'prop-types';

import { CommonButton, LinkButton, ReactLinkButton } from './styles';

export const Button = React.forwardRef((props, ref) => {
    if (props.type === 'link') {
        return (
            <LinkButton ref={ref} data-testid={props.dataTestId} {...props}>
                {props.caption}
            </LinkButton>
        );
    }
    if (props.type === 'reactLink') {
        return (
            <ReactLinkButton ref={ref} data-testid={props.dataTestId} {...props}>
                {props.caption}
            </ReactLinkButton>
        );
    }
    return (
        <CommonButton ref={ref} data-testid={props.dataTestId} {...props}>
            {props.caption}
        </CommonButton>
    );
});

Button.propTypes = {
    type: PropTypes.oneOf(['button', 'submit', 'link', 'reactLink']),
    variant: PropTypes.oneOf(['primary', 'secondary', 'secondary_base', 'tertiary', 'error', 'danger', 'hidden', 'row']),
    size: PropTypes.oneOf(['tight', 'fit']),
    raised: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    disabled: PropTypes.bool,
    isInverted: PropTypes.bool,
    href: PropTypes.string,
    to: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
    tabIndex: PropTypes.string,
    form: PropTypes.string, // для того, чтобы можно было связывать кнопку submit по id с form, если она находится вне form (н-р в попапах)
    caption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    dataTestId: PropTypes.string, // для html аттрибута data-testid (babel plugin "react-remove-properties")
    negativeMargin: PropTypes.bool, // чтобы выравнивать row-кнопки по контенту
    onClick: PropTypes.func,
    textCenter: PropTypes.bool,
};
